export const BRAND_ID = '38676108-A779-4563-AEB4-93C8C356C226';

